import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm2.6-10.6H9.4v5.2h5.2V9.4z" }));
export default createSvgIcon(iconPath, "Quarantined");
//# sourceMappingURL=StatusQuarantinedIcon.js.map